import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import ConfirmDialog from './ConfirmDialog.jsx';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import {TextArea, Text, TextMessage} from 'components/tt-forms/common';
import { GiaiQuyetDonThu } from 'api';
import { Link, browserHistory } from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class CanBoGiaiQuyetYeuCauLapDuThao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      onSave: false,
      id: this.props.id,
      role: this.props.role,
      loaiDon: this.props.loaiDon,
      validate: false,
      showAttach: false,
      yKienGiaiQuyet: '',
      noiDungKetLuanDuThao: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      nextState: 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      hasChange: false,
      backConfirm: false
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  componentWillUnmount() {

  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      loaiDon: nextProps.loaiDon
    })
  }

  onChange(name, e) {
    this.hasChange();
    this.setState({
      [name]: e.target.value
    });
    if (name== 'nextState') {

    }
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            canBoGiaiQuyet: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            noiDungKetLuanDuThao: res.data.noiDungKetLuanDuThao ? res.data.noiDungKetLuanDuThao : '',
            ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
            ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX): ''
          },()=> {
            this.renderAttachFile()
          });
        }
      });
    }
  }

  onClickClose(type) {
    if (type == true) {
      browserHistory.goBack()
    } else if (this.state.hasChange) {
      this.setState({
        backConfirm: true
      })
    } else {
      browserHistory.goBack()
    }
  }

  closeConfirmBack() {
    this.setState({
      backConfirm: false
    })
  }

  hasChange() {
    this.setState({
      hasChange: true
    })
  }

  handleChangeDate(name, e) {
    this.hasChange();
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.hasChange();
  }

  getParams() {
    let params = getParams(this.state.dataGiaiQuyetDon, this.state.id);

    params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao ? this.state.noiDungKetLuanDuThao : '';
    return params;
  }

  handleSave(){
    this.setState({
      onSave: true
    }, () => {
      if(this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem();
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let params = this.getParams();

        params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao;

        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.saveGiaiQuyetDon(params);
            });
          });
        });
      }
    })
  }

  handleGiaiQuyetDon(type) {
    this.setState({
      onSave: false
    }, ()=> {
      if(this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let _params = this.getParams();
        let params = {};

        if (this.props.tuGiaiQuyet == true) {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            actionType: 'TTXM_GUI_DU_THAO',
            yKienGiaiQuyet: this.state.noiDungKetLuanDuThao
          }
        } else {
          let selectedState = this.props.dataNextStates.filter(state => {
            return state.type == this.state.nextState
          });

          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.noiDungKetLuanDuThao
          }
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.updateGiaiQuyetDon(_params, params, 'gqdGuiDuThao');
            });
          });
        });
      }
    })
  }

  onFileChange(data, type) {
    this.hasChange();
    if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.hasChange();
  }

  onFileRemove(id, data, type) {
    this.hasChange();
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.hasChange();

  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0 ) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime >= secondTime  && type == 'show') {
      return true
    } else {
      return false
    }
  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let DataTaiLieuVanThuView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), 'action');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
      return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), new Date(state.ngayTao), 'show');
    })

    let data = [...listTaiLieuVanThuGiaiQuyetDon];
    let dataCheck = data.filter(item => {
      return item.required && item.typeRequired == 'DT_KL_GQKN'
    })
    if (dataCheck.length > 0) {
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon:listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        showAttach: true
      })
    } else {
      let DT_KL = {
        ten: 'Dự thảo quyết định về việc giải quyết khiếu nại',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'DT_KL_GQKN',
        newFile: true
      }
      let TT_KL = {
        ten: 'Tờ trình đề nghị ban hành QĐGQ khiếu nại',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'DT_KL_GQKN',
        newFile: true
      }
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: [
          ...this.state.listTaiLieuVanThuGiaiQuyetDon,
          TT_KL,
          DT_KL
        ],
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        showAttach: true
      })
    }

  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    })
    this.handleGiaiQuyetDon();
  }
  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }
  updateGiaiQuyetDon(params, _params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.postGiaiQuyetDon(_params, message);
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      this.onClickClose(true);
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  render() {
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block">
        <NhiemVuTTXM
          donViGiaoThamTraXacMinh={this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo}
          ngayBatDauTTXM={this.state.dataGiaiQuyetDon.ngayBatDauTTXM}
          yKienCuaDonViGiaoTTXM = {this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM}
          ngayHetHanTTXM={this.state.dataGiaiQuyetDon.ngayHetHanTTXM}
          donInfo={this.props.donInfo}
          lanhDaoView={this.props.lanhDaoView}
          />
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <div className="col-100 no-gutter">
              <div className="col-100 pt5 pb15">
                <span className="line-border"></span>
              </div>
              <h3 className="txt-upper title-14 mt0 mb15 pl5 pr5">Báo cáo kết quả xác minh{lb2}</h3>
              <div className="col-100 mb15 no-gutter">
                <Text className="col-25 mb10" label={"Đơn vị "+lb1+":"} value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : ''}/>
                <Text className="col-25 mb10" red={true} label="Thời gian báo cáo kết quả:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanTTXM ? moment(this.state.dataGiaiQuyetDon.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
                <Text className="col-25 mb10" label="Ngày báo cáo kết quả:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM ? moment(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : ''}/>
                <TextMessage className='col-100' label='Ý kiến xử lý:' value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDung ? this.state.dataGiaiQuyetDon.noiDung : ''}/>
              </div>

              <div className="col-100 pt5 pb15">
                <span className="line-border"></span>
              </div>

              <div className="col-100">
                <div className="col-100 no-gutter mt5 pb10">
                  <h2 className="title-12 mb15">Đối thoại</h2>
                  <div className="row pl10 pr10">
                    <Text className="col-25 mb10" label="Thời gian đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.thoiGianDoiThoai ? moment(this.state.dataGiaiQuyetDon.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
                    <Text className="col-75 mb10" label="Địa điểm:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.diaDiemDoiThoai ? this.state.dataGiaiQuyetDon.diaDiemDoiThoai : ''}/>
                    <TextMessage className="col-100 mb0-18" label="Nội dung, kết quả đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungDoiThoai ? this.state.dataGiaiQuyetDon.noiDungDoiThoai : ''}/>
                  </div>
                </div>
              </div>

              <div className="col-100 pt5 pb15">
                <span className="line-border"></span>
              </div>

              <div className="col-100">
                <div className="col-100 no-gutter mt5 pb10">
                  <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
                  <div className="row pl10 pr10">
                    <Text className="col-25 mb10" label="Thời gian trình dự thảo:" red={true} value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao ? moment(this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                    <TextMessage className="col-100 mb0-18" label="Ý kiến xử lý:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao ? this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao : ''}/>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>

        <h2 className="title-14 mb15">Dự thảo quyết định giải quyết khiếu nại</h2>
        <form className="form-action">
          <div className="row pl10 pr10">
            <TextArea value={this.state.noiDungKetLuanDuThao} className="areal-wrap col-100" label="Tóm tắt nội dung kết quả đối thoại" placeholder="Nhập..." onChange={this.onChange.bind(this, 'noiDungKetLuanDuThao')} name="textareaChonCanBoGiaiQuyet"/>
            <ShowIf condition={this.state.showAttach}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView} data={this.state.listTaiLieuVanThuGiaiQuyetDon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
          </div>
        </form>
        <div className='col-100 no-gutter'>
          <div className='wrap-gqd-kqt'>
            <div className="box-bottom gqd-wrap col-100 mt20 pt30">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this)}><span>Gửi dự thảo</span></Link>
              <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title="Xác nhận" content={"Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') +" dự thảo của đơn/vụ việc này không?"}/>
            </div>
          </div>
        </div>
        <ConfirmDialog open={this.state.backConfirm}
          onClose={this.closeConfirmBack.bind(this)}
          onSuccess={this.onClickClose.bind(this, true)}
          title='Xác nhận'
          content={msg.confirmBack} />
      </section>
    );
  }
}

CanBoGiaiQuyetYeuCauLapDuThao.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(CanBoGiaiQuyetYeuCauLapDuThao)


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/CanBoGiaiQuyetYeuCauLapDuThao.jsx